import React, { useEffect, useRef } from "react";
import { cn } from "../../lib/utils";

// Light-theme only, Material-inspired. Smooth fade & scale animations.
export function Dialog({ open, onOpenChange, maxWidth, children }) {
  if (!open) return null;
  return (
    <div
      className="cbc-dialog fixed inset-0 z-50 flex items-center justify-center"
      aria-modal="true"
      role="dialog"
    >
      <div
        className="absolute inset-0 bg-black/40 opacity-100 animate-[fadeIn_120ms_ease-out]"
        onClick={() => onOpenChange?.(false)}
      />
      {/* .cbc-dialog-panel: styles/mobile.css turns this into a full-screen
          sheet in the phone layout, so every existing dialog fits a phone. */}
      <div
        className={`cbc-dialog-panel relative rounded-2xl bg-white shadow-2xl border border-gray-100
                   animate-[scaleIn_160ms_cubic-bezier(0.2,0.8,0.2,1)]
                   ${maxWidth || "w-[min(640px,92vw)] max-w-lg"}`}
      >
        {/* Phone layout only (display:none otherwise): the backdrop is covered
            by the full-screen panel, so give the thumb an explicit close. */}
        <button
          type="button"
          className="cbc-dialog-close"
          aria-label="Close"
          onClick={() => onOpenChange?.(false)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
        </button>
        {children}
      </div>
      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes scaleIn { from { opacity: 0; transform: translateY(6px) scale(0.98) }
                             to { opacity: 1; transform: translateY(0) scale(1) } }
      `}</style>
    </div>
  );
}

export function DialogContent({ className = "", children }) {
  return <div className={cn("p-6", className)}>{children}</div>;
}

export function DialogHeader({ className = "", children }) {
  return <div className={cn("mb-3", className)}>{children}</div>;
}

export function DialogTitle({ className = "", children }) {
  return <h2 className={cn("text-xl font-semibold text-gray-900", className)}>{children}</h2>;
}

export function DialogFooter({ className = "", children }) {
  return <div className={cn("mt-4 flex justify-end gap-2", className)}>{children}</div>;
}
